import { makeStyles } from "@material-ui/core/styles";
import { KeyboardDatePicker, KeyboardDatePickerProps } from "@material-ui/pickers";
const styles = makeStyles({
	paper: {
		"& .MuiPickersToolbar-toolbar": {
			backgroundColor: "#ffff",
			height: "64px",
		},
		"& .MuiPickersDay-day": {
			width: "28px",
			height: "28px",
		},
		"& .MuiPickersBasePicker-pickerView": {
			minWidth: "272px",
			minHeight: "292px",
		},
		"& .MuiPickersCalendar-transitionContainer": {
			minHeight: "180px",
		},
		"& .MuiPickersToolbarText-toolbarTxt": {
			color: "black",
		},
		"& .MuiPickersToolbarButton-toolbarBtn": {
			"&:last-child": {
				display: "none",
			},
		},
	},
});

export default function LyfeKeyboardDatePicker(props: KeyboardDatePickerProps) {
	const classes = styles();
	return <KeyboardDatePicker PopoverProps={{ className: classes.paper }} {...props} />;
}
